<template>
	<div class="main-page">
		<header>
		  	<div class="alert alert-warning" v-show="is_show">
		  		您还没有完善供应商信息，所提交的供货信息仅当前浏览器可见。为了便于经销商确认报价并与您取得联系，建议尽快<a href="javascript:;" @click="openEditInfoModal">完善信息</a>！
		  	</div>
		  	<div class="header">
		  		<h1>
			    	<router-link :to="{ path: '/' }"></router-link>
			   </h1>
		  	</div>
		</header>
		<section class="filter-box" :class="is_show ? 'showMargin' : ''">
			<h1>我的历史报价信息</h1>
		</section>
		<list :total="totalPage" :items="items" :last="isLastPage" @offerAgain="offerAgain" @openRegModal="openRegModal"/>
		<InnerLoading v-show="itemsLoading" />
		<!--<footerWrap :type="type"/>-->
		<footer>
			<div>
				<a style="margin: 0 auto;"
	            id="v-step-1"
	            class="btn btn-primary"
	            href="javascript:;"
	            @click="openOffer"
	          >查看更多热卖商品</a>
			</div>
	    </footer>
		<PageLoading :show="loading" />
	</div>
</template>

<script>
import Header from "./../components/header.vue";
import filterBox from "./../components/filter.vue";
import list from "./../components/list-offer-his.vue";
import footerWrap from "./../components/footer.vue";
import InnerLoading from "./../components/innerLoading";
import PageLoading from "./../components/pageLoading";
export default {
	props:["is_show"],
  data() {
    return {
    	type:3,
    	loading: false,
      	firstLoading: true,
      	itemsLoading: false,
      	page: 1,
      	rowsPerPage: 20,
      	totalCount: 0,
      	items: [],
      	totalPage: 1,
      	isLastPage: false,
    };
  },
  components: {
    Header,
    filterBox,
    list,
    footerWrap,
    InnerLoading,
    PageLoading,
  },
  mounted() {
  	this.getList();
  	window.addEventListener("scroll", e => {
      this.scrollGetList();
    });
  },
  watch: {
  },
  methods: {
  	openOffer(){
  		this.$router.push({ name: 'page' })
  	},
  	offerAgain(id){
  		let arr = [];
  		arr.push(id);
  		let canSupplyItems = [];
  		this.items.forEach((s)=>{
  			if(id == s.id){
  				canSupplyItems.push(s);
  			}
		})
  		this.$router.push({ name: 'pageOffer',query: {type:this.type},params: { ids: arr,items:this.items,canItems:canSupplyItems }});
  		localStorage.setItem("canSupplyItemsAgain", JSON.stringify(canSupplyItems));
  	},
  	openRegModal(type){
  		this.$emit("openRegModal",type);
  	},
  	openEditInfoModal(){
  		this.$emit("openEditInfoModal");
  	},
  	getList() {
//		if(!localStorage.getItem("supplierPriceInfo")){
//			this.openRegModal(1);
//			return;
//		}
      if (this.itemsLoading) return;
      if (this.page > this.totalPage) {
        this.isLastPage = true;
        return;
      }
			if(this.$route.query.token){
				if(this.page ==1){
					localStorage.removeItem("supplierPriceInfo");
				}
			}else{
				if(!localStorage.getItem("supplierPriceInfo") || (localStorage.getItem("supplierPriceInfo")
				&& JSON.parse(localStorage.getItem("supplierPriceInfo")).fromUrl && !localStorage.getItem("alertEditInfo") && !localStorage.getItem			 ("supplierPriceInfoLogin"))){
					this.$emit("openRegModal",this.type);
				}
			}
      this.itemsLoading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        supplierId: localStorage.getItem("supplierPriceInfo")? JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId : "",
				id:this.$route.query.id ? this.$route.query.id : "",
				token:this.$route.query.token ? this.$route.query.token : "",
      };
      this.$apiCall("api.OfferProduct.findDetails", params, r => {
        this.itemsLoading = false;
        this.firstLoading = false;
        if (r.data.ErrorCode == "9999") {
          r.data.Data.Results.forEach(item => {
            this.items.push(item);
          });
					localStorage.setItem("supplierPriceInfo",JSON.stringify(r.data.Data.Results[0].supplierArr));
					if(this.$route.query.token){
						localStorage.setItem("supplierPriceInfoLogin",r.data.Data.Results[0].supplierArr.supplierId);
					}
					
          this.totalCount = r.data.Data.Pagination.totalCount;
          this.totalPage = r.data.Data.Pagination.totalPage;
          this.page++;
          setTimeout(() => {
            this.scrollGetList();
          }, 100);
          setTimeout(() => {
            this.$previewRefresh(); //重置图片预览
          }, 200);
        } else {
          this.$toasted.show(
            `<i class="iconfont icon-warning"></i> ${r.data.Message}`,
            {
              theme: "primary",
              position: "top-center",
              className: "danger",
              duration: this.page == 1 ? 9999999 : 3000
            }
          );
        }
      });
    },
    scrollGetList() {
      let scrollT =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollT + window.innerHeight >= document.body.offsetHeight - 300) {
        this.getList();
      }
    },
  }
};
</script>

<style lang="less" scoped>
@import "./../assets/style/config.less";
</style>